import script from "./AdminOrgManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOrgManagement.vue?vue&type=script&setup=true&lang=js"

import "./AdminOrgManagement.vue?vue&type=style&index=0&id=3d00ff4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d00ff4a"]])

export default __exports__